/**
 * Site Configuration Validators
 * Phase 27: Backend Admin API - Site Config Management
 */
import { z } from "zod";
/**
 * Site Config Input Schema
 */
export const siteConfigInputSchema = z.object({
    domain: z
        .string()
        .min(1, "Domain is required")
        .max(255)
        .regex(/^[a-z0-9.-]+\.[a-z]{2,}$/i, "Invalid domain format"),
    is_active: z.boolean().optional().default(true),
    vehicle_container_selector: z
        .string()
        .min(1, "Vehicle container selector is required")
        .max(500),
    variant_selector: z.string().min(1, "Variant selector is required").max(500),
    brand_selector: z.string().max(500).optional(),
    model_selector: z.string().max(500).optional(),
    mileage_selector: z.string().max(500).optional(),
    fuel_selector: z.string().max(500).optional(),
    transmission_selector: z.string().max(500).optional(),
    power_selector: z.string().max(500).optional(),
    vin_selector: z.string().max(500).optional(),
    year_selector: z.string().max(500).optional(),
    vehicle_type_selector: z.string().max(500).optional(),
    notes: z.string().max(1000).optional(),
});
/**
 * Site Config Update Schema (partial)
 */
export const siteConfigUpdateSchema = siteConfigInputSchema.partial();
/**
 * Site Config Test Schema
 */
export const siteConfigTestSchema = z.object({
    testUrl: z.string().url("Invalid URL format").optional(),
    testHtml: z.string().optional(),
}).refine((data) => data.testUrl || data.testHtml, { message: "Either testUrl or testHtml must be provided" });
/**
 * Site Config Query Schema
 */
export const siteConfigQuerySchema = z.object({
    domain: z.string().optional(),
    active: z
        .string()
        .optional()
        .transform((val) => (val === "true" ? true : val === "false" ? false : undefined)),
    limit: z
        .string()
        .optional()
        .default("20")
        .transform((val) => parseInt(val, 10)),
    offset: z
        .string()
        .optional()
        .default("0")
        .transform((val) => parseInt(val, 10)),
});
//# sourceMappingURL=siteConfig.schema.js.map